<template>
  <div class="time-selector">
    <select v-model="hour">
      <option v-for="h in 12" :key="h" :value="padZero(h)">
        {{ padZero(h) }}
      </option>
    </select>

    <span id="span">:</span>

    <select v-model="minute">
      <option v-for="m in 60" :key="m" :value="padZero(m - 1)">
        {{ padZero(m - 1) }}
      </option>
    </select>

    <select v-model="period">
      <option value="AM">AM</option>
      <option value="PM">PM</option>
    </select>
  </div>
</template>

<script>
import { ref, watch, defineComponent,onMounted } from 'vue'

export default defineComponent({
  name: 'TimeSelector',
  props: {
    modelValue: {
      type: String,
      default: '12:00 AM'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const padZero = (n) => n.toString().padStart(2, '0')
    const [defaultHour, defaultMinute, defaultPeriod] = parseTime(props.modelValue)

    const hour = ref(defaultHour)
    const minute = ref(defaultMinute)
    const period = ref(defaultPeriod)


    function parseTime(timeStr) {
      const match = timeStr.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i)
      if (!match) return ['12', '00', 'AM']
      return [padZero(match[1]), padZero(match[2]), match[3].toUpperCase()]
    }

    function emitTime() {
      emit('update:modelValue', `${hour.value}:${minute.value} ${period.value}`)
    }

    onMounted(() => {
        emitTime()
    })

    // Emit whenever any value changes
    watch([hour, minute, period], emitTime)

    return {
      hour,
      minute,
      period,
      padZero,
    }
  }
})
</script>

<style scoped>
.time-selector {
  display: flex;
  align-items: center;
    background-color: var(--input-bg);
}
select {
    padding: 10px 15px;
    font-size: 16px;
    color: #8a97a0;
    background-color: var(--input-bg);
    border: 0;
}
#span{margin: 0 10px; font-weight: bold; color: var(--black);
    font-size: 20px;}
</style>
